import axios from "axios"
import get from "lodash/get"
import { urls } from "utils-lib/builds"
import {
  SUBMIT_CONTACT_BACK_CASE_PENDING,
  SUBMIT_CONTACT_BACK_CASE_FULFILLED,
  SUBMIT_CONTACT_BACK_CASE_FAILED,
} from "constants-lib/actionTypes"
import { generateUniqueID } from "utils-lib/requests"

export const pendingAC = () => ({
  type: SUBMIT_CONTACT_BACK_CASE_PENDING,
})
export const failedAC = () => ({
  type: SUBMIT_CONTACT_BACK_CASE_FAILED,
})
export const fulfilledAC = (data) => ({
  type: SUBMIT_CONTACT_BACK_CASE_FULFILLED,
  payload: data,
})

// TODO: Finalize changes one API is delivered
export const createContactBackCase =
  ({
    customer_id,
    first_name,
    last_name,
    mobile_phone,
    email,
    service_address,
    category,
    sub_category,
    lob,
    waste_stream,
    customer_notes,
    campaign,
    user = null,
  }) =>
  (dispatch, getState) => {
    dispatch(pendingAC())
    const { customerSelections } = getState()

    const api = `CONTACT_BACK_CREATE_CASE`
    const url = urls.url[api]

    const config = {
      headers: {
        "Request-Tracking-Id": generateUniqueID(),
        "Source-App": `WM.com`,
        "Content-Type": `application/json`,
        Authorization: `Bearer`,
      },
    }

    const data = {
      customer_id,
      first_name,
      last_name,
      mobile_phone,
      email,
      lob,
      waste_stream,
      service_address:
        service_address ||
        get(customerSelections, `customerAddress.formattedAddress`, ``),
      category: category || ``,
      sub_category: sub_category || ``,
      customer_notes,
      campaign,
      // contact back get attributes data
      sla_time: get(
        customerSelections,
        `contactBackAttributesData.sla_time`,
        ``,
      ),
      sla_unit: get(
        customerSelections,
        `contactBackAttributesData.sla_unit`,
        ``,
      ),
      market_area: get(
        customerSelections,
        `contactBackAttributesData.market_area`,
        ``,
      ),
      configurator_record_id: get(
        customerSelections,
        `contactBackAttributesData.configurator_record_id`,
        ``,
      ),
      language: "eng", // wtf???
    }

    if (user) {
      data.user = user
    }

    return axios
      .create(config)
      .post(url, data)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return { data: response.data, statusCode: response.status }
      })
      .catch((e) => {
        dispatch(failedAC())
        return e
      })
  }
